import React from 'react';
import * as S from './styles';
import getCountryISO2 from 'country-iso-3-to-2';

interface CountryFlagProps {
  countryId: string;
  altText: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ countryId, altText }) => {
  const countryISO2 = getCountryISO2(countryId)?.toLowerCase();
  const flagSrc = `https://flagcdn.com/16x12/${countryISO2}.png`;
  return <S.CountryFlag src={flagSrc} width="16" height="12" alt={altText} />;
};

export default CountryFlag;
